/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { UserQuizQuestionAnswerDto } from '../models';
// @ts-ignore
import type { UserQuizStateDto } from '../models';
/**
 * RestUserQuizAnswerApi - axios parameter creator
 * @export
 */
export const RestUserQuizAnswerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary answer current quiz question
         * @param {string} userId 
         * @param {string} userQuizId 
         * @param {UserQuizQuestionAnswerDto} userQuizQuestionAnswerDto User question answer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        answerUserQuizQuestion: async (userId: string, userQuizId: string, userQuizQuestionAnswerDto: UserQuizQuestionAnswerDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('answerUserQuizQuestion', 'userId', userId)
            // verify required parameter 'userQuizId' is not null or undefined
            assertParamExists('answerUserQuizQuestion', 'userQuizId', userQuizId)
            // verify required parameter 'userQuizQuestionAnswerDto' is not null or undefined
            assertParamExists('answerUserQuizQuestion', 'userQuizQuestionAnswerDto', userQuizQuestionAnswerDto)
            const localVarPath = `/api/users/{userId}/quizzes/{userQuizId}/questions/answer`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"userQuizId"}}`, encodeURIComponent(String(userQuizId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userQuizQuestionAnswerDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestUserQuizAnswerApi - functional programming interface
 * @export
 */
export const RestUserQuizAnswerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestUserQuizAnswerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary answer current quiz question
         * @param {string} userId 
         * @param {string} userQuizId 
         * @param {UserQuizQuestionAnswerDto} userQuizQuestionAnswerDto User question answer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async answerUserQuizQuestion(userId: string, userQuizId: string, userQuizQuestionAnswerDto: UserQuizQuestionAnswerDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserQuizStateDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.answerUserQuizQuestion(userId, userQuizId, userQuizQuestionAnswerDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestUserQuizAnswerApi.answerUserQuizQuestion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestUserQuizAnswerApi - factory interface
 * @export
 */
export const RestUserQuizAnswerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestUserQuizAnswerApiFp(configuration)
    return {
        /**
         * 
         * @summary answer current quiz question
         * @param {string} userId 
         * @param {string} userQuizId 
         * @param {UserQuizQuestionAnswerDto} userQuizQuestionAnswerDto User question answer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        answerUserQuizQuestion(userId: string, userQuizId: string, userQuizQuestionAnswerDto: UserQuizQuestionAnswerDto, options?: RawAxiosRequestConfig): AxiosPromise<UserQuizStateDto> {
            return localVarFp.answerUserQuizQuestion(userId, userQuizId, userQuizQuestionAnswerDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestUserQuizAnswerApi - interface
 * @export
 * @interface RestUserQuizAnswerApi
 */
export interface RestUserQuizAnswerApiInterface {
    /**
     * 
     * @summary answer current quiz question
     * @param {string} userId 
     * @param {string} userQuizId 
     * @param {UserQuizQuestionAnswerDto} userQuizQuestionAnswerDto User question answer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestUserQuizAnswerApiInterface
     */
    answerUserQuizQuestion(userId: string, userQuizId: string, userQuizQuestionAnswerDto: UserQuizQuestionAnswerDto, options?: RawAxiosRequestConfig): AxiosPromise<UserQuizStateDto>;

}

/**
 * RestUserQuizAnswerApi - object-oriented interface
 * @export
 * @class RestUserQuizAnswerApi
 * @extends {BaseAPI}
 */
export class RestUserQuizAnswerApi extends BaseAPI implements RestUserQuizAnswerApiInterface {
    /**
     * 
     * @summary answer current quiz question
     * @param {string} userId 
     * @param {string} userQuizId 
     * @param {UserQuizQuestionAnswerDto} userQuizQuestionAnswerDto User question answer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestUserQuizAnswerApi
     */
    public answerUserQuizQuestion(userId: string, userQuizId: string, userQuizQuestionAnswerDto: UserQuizQuestionAnswerDto, options?: RawAxiosRequestConfig) {
        return RestUserQuizAnswerApiFp(this.configuration).answerUserQuizQuestion(userId, userQuizId, userQuizQuestionAnswerDto, options).then((request) => request(this.axios, this.basePath));
    }
}

